/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';

/**
 * 
 * @export
 * @interface CreateOrUpdateInstructionDto
 */
export interface CreateOrUpdateInstructionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateInstructionDto
     */
    textAreaContent?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateOrUpdateInstructionDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateInstructionDto
     */
    $type?: CreateOrUpdateInstructionDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateInstructionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateOrUpdateInstructionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateInstructionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOrUpdateInstructionDtoTypeEnum = typeof CreateOrUpdateInstructionDtoTypeEnum[keyof typeof CreateOrUpdateInstructionDtoTypeEnum];


/**
 * Check if a given object implements the CreateOrUpdateInstructionDto interface.
 */
export function instanceOfCreateOrUpdateInstructionDto(value?: unknown): value is CreateOrUpdateInstructionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateInstructionDtoTypeEnum)[0];
}

export function CreateOrUpdateInstructionDtoFromJSON(json: any): CreateOrUpdateInstructionDto {
    return CreateOrUpdateInstructionDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateInstructionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateInstructionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'textAreaContent': !exists(json, 'textAreaContent') ? undefined : json['textAreaContent'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateOrUpdateInstructionDtoToJSON(value?: CreateOrUpdateInstructionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'textAreaContent': value.textAreaContent,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        '$type': value.$type,
    });
}

